module.exports = __webpack_public_path__ + "img/invOfflineFlow.18cd2ed0.jpg";